// Tutti i set di chiavi per i vari tipi di telaio/rami
export const TELAI_KEYS = {
    SS: ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 's9', 's10', 's11', 's12', 'a', 'b', 'c', 'd', 'e', 'f', 'p', 'q', 'r', 't', 'v', 'z'],
    SD_RAMO: ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 'a', 'b', 'c', 'd', 'p', 'q'],
    SD_CUORE: ['s7', 's8', 'p', 'q'],
    SI_T1: ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 's9', 's10', 's11', 's12', 'a', 'b', 'c', 'd', 'e', 'f', 'p', 'q', 'r', 't', 'v', 'z'],
    SI_T2: ['s1', 's2', 's3', 's4', 's5', 's6', 'a', 'b', 'c', 'd'],
    SI_T3: ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 'a', 'b', 'c', 'd', 'p', 'q'],
    SI_T4: ['s1', 's2', 's3', 's4', 's5', 's6', 'a', 'b', 'c', 'd']
};

// Campi indagine visiva
export const INDAGINE_VISIVA = {
    SS: [
        'usuraTelaioAd',
        'usuraTelaioCd',
        'usuraTelaioAs',
        'usuraTelaioCs',
        'usuraTelaioCuore',
        'coppiaActDestro',
        'coppiaActSinistro',
        'coppiaActNote',
        'traverseSostTelaio',
        'traverseSostIntermedia',
        'traverseSostCuore',
        'legnamiSostTelaio',
        'legnamiSostIntermedia',
        'legnamiSostCuore',
        'traverseNote',
        'attacchiSostTelaio',
        'attacchiSostIntermedia',
        'attacchiSostCuore',
        'bulloniSostTelaio',
        'bulloniSostIntermedia',
        'bulloniSostCuore',
        'attBulNote',
        'noteIndagineVisiva'
    ],
    SD: [
        'usuraAgot1Destro',
        'usuraContrAgot1Destro',
        'usuraAgot1Sinistro',
        'usuraContrAgot1Sinistro',
        'usuraAgot2Destro',
        'usuraContrAgot2Destro',
        'usuraAgot2Sinistro',
        'usuraContrAgot2Sinistro',
        'usuraCuore1',
        'usuraCuore2',
        'usuraCuore3',
        'coppiaAct1Destra',
        'coppiaAct1Sinistra',
        'coppiaAct2Destra',
        'coppiaAct2Sinistra',
        'coppiaActNote',
        'traverseSostTelaio',
        'traverseSostIntermedia',
        'traverseSostCuore',
        'legnamiScorrTelaio',
        'legnamiScorrIntermedia',
        'legnamiScorrCuore',
        'traverseNote',
        'attacchiSostTelaio',
        'attacchiSostIntermedia',
        'attacchiSostCuore',
        'bulloniSostTelaio',
        'bulloniSostIntermedia',
        'bulloniSostCuore',
        'attBulNote',
        'noteIndagineVisiva'
    ],
    SI: [
        'usuraAgot1Destro',
        'usuraContrAgot1Destro',
        'usuraAgot1Sinistro',
        'usuraContrAgot1Sinistro',
        'usuraCuoret1',
        'usuraAgot2Destro',
        'usuraContrAgot2Destro',
        'usuraAgot2Sinistro',
        'usuraContrAgot2Sinistro',
        'usuraCuoret2',
        'usuraAgot3Destro',
        'usuraContrAgot3Destro',
        'usuraAgot3Sinistro',
        'usuraContrAgot3Sinistro', 
        'usuraCuoret3',
        'usuraAgot4Destro',
        'usuraContrAgot4Destro',
        'usuraAgot4Sinistro',
        'usuraContrAgot4Sinistro',
        'usuraCuoret4',
        'coppiaAct1Destra',
        'coppiaAct1Sinistra',
        'coppiaAct2Destra',
        'coppiaAct2Sinistra',
        'coppiaAct3Destra',
        'coppiaAct3Sinistra',
        'coppiaAct4Destra',
        'coppiaAct4Sinistra',
        'coppiaActNote',
        'traverseSostTelaio',
        'traverseSostIntermedia',
        'traverseSostCuore',
        'legnamiScorrTelaio',
        'legnamiScorrIntermedia',
        'legnamiScorrCuore',
        'traverseNote',
        'attacchiSostTelaio',
        'attacchiSostIntermedia',
        'attacchiSostCuore',
        'bulloniSostTelaio',
        'bulloniSostIntermedia',
        'bulloniSostCuore',
        'attBulNote',
        'noteIndagineVisiva'
    ]
};

///// COSTANTI LISTE

export const GIUDIZIO = ['Buono', 'Sufficiente', 'Scarso'];
export const PERCENTUALI = ['100', '75', '50', '30', '20', '10', '0'];
export const URGENZA = ['Lunga', 'Media', 'Breve', 'Brevissima'];
export const STATO = ['Normale', 'Usurato', 'Da sostituire'];
export const CONSUMO = ['Normale', 'Usurato', 'Da ripristinare'];
export const RIFLUSSO_RISTAGNO = ['Assente', 'Presente', 'Grave'];
export const TIRANTERIA = ['Presente', 'Da installare', 'N.N.'];
export const RIFOLLATORE = ['Telaio', 'Intermedia', 'Cuore', 'Totale'];
export const TOLLERAZANZE = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];


